import { combineReducers } from 'redux'

import settings from './settings'
import media from './media'

import { reducer as references } from './modules/ImageReferences'
import { reducer as chapters } from './modules/Chapters'
import { reducer as dimensions } from './modules/Dimensions'
import { reducer as glossary } from './modules/Glossary'
import { reducer as resources } from './modules/Resources'
import { reducer as intro } from './modules/Introduction'
import { reducer as favourites } from './modules/Favourites'

const reducer = combineReducers({
    settings,
    media,
    references,
    chapters,
    dimensions,
    glossary,
    resources,
    intro,
    favourites
})

export default reducer



// WEBPACK FOOTER //
// ./client/reducer.js